<!--
 * @Author: Lemon C
 * @Date: 2024-04-26 15:49:57
 * @LastEditTime: 2025-03-12 18:31:09
-->
<template>
    <div class="sup-docs-type-switch-box">
        <div class="type-switch-btn-box" v-if="switch_type === 0">
            <div
                class="switch-item"
                :class="{ 'switch-item-active': item.isActive }"
                v-for="(item, index) in typeList"
                :key="index"
                @click="type_switch_action(item)">
                {{ item.name }}
            </div>
        </div>
        <div class="type-switch-title-box" v-if="switch_type === 1">
            <span>{{ title_name }}</span>
        </div>
        <div class="type-switch-search-box" v-if="needSerarch">
            <el-input class="search-input" prefix-icon="Search" v-model="search_input" placeholder="全局文档搜索" @change="search_click"></el-input>
            <div class="search-btn" @click="search_click">搜索</div>
        </div>
    </div>
</template>

// MOD-- JavaScript
<script setup>
import { ref, onBeforeMount, getCurrentInstance } from 'vue';
import { useRouterStore } from '@/stores/router';

const router_store = useRouterStore();
const { proxy } = getCurrentInstance();

const props = defineProps({
    switch_type: {
        type: Number,
        default: 0,
    }, // 样式类型 0: 选择类型  2：标题类型
    title_name: String, // 标题
    currId: {
        type: Number,
        default: 101,
    }, //当前选中id
    needSerarch: {
        type: Boolean,
        default: false,
    }, //是否需要搜索
    docs_type_switch_click: Function, //点击回调
});

const typeList = ref(proxy.$globalObj.docs_switch_list); // 类型列表
const search_input = ref(''); //搜索

onBeforeMount(() => {
    typeList.value.forEach((e) => {
        e.isActive = false;
        if (e.id === props.currId) {
            e.isActive = true;
        }
    });
});

// MARK 类型选择
const type_switch_action = (item) => {
    props.docs_type_switch_click(item);
};

// MARK Click  搜索点击
const search_click = () => {
    if (!search_input.value || /^\s*$/.test(search_input.value)) {
        //^ 表示匹配字符串的开始位置, \s* 表示匹配零个或多个空白字符（包括空格、制表符、换页符等）, $ 表示匹配字符串的结束位置。
        proxy.$message.warning('请输入全局文档搜索内容！');
        return;
    }
    router_store.navigateToSearch({ keywords: search_input.value, fromType: props.currId });
};
</script>

// MOD-- CSS
<style lang="less" scoped>
.sup-docs-type-switch-box {
    display: flex;
    height: 80px;
    width: 100%;
    align-items: center;
    background-color: var(--color-main-light-bg-white);
    border-bottom: 1px solid var(--color-main-border-gray);
    transition: background-color 0.3s linear;
    /* 添加过渡效果 */

    .type-switch-title-box {
        position: relative;
        display: flex;
        flex: 1;
        height: 100%;
        padding-left: 48px;
        box-sizing: border-box;
        align-items: center;

        span {
            font-weight: 500;
            font-size: 28px;
            color: var(--color-main-text-primary);
            line-height: 41px;
        }
    }

    .type-switch-btn-box {
        position: relative;
        display: flex;
        flex: 1;
        padding-left: 48px;
        box-sizing: border-box;

        .switch-item {
            position: relative;
            width: 107px;
            height: 35px;
            border-radius: 3px;
            font-size: 13px;
            line-height: 24px;
            font-weight: 400;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-right: 30px;
            cursor: pointer;
            background: var(--color-main-doc-switch-item-bg);
            color: var(--color-main-text-primary);

            &:hover {
                background: var(--color-main-brand-active);
                color: var(--color-main-text-brand-bg-primary);
            }
        }

        @media screen and (max-width: 1600px) {
            .switch-item {
                margin-right: 10px;
            }
        }

        .switch-item-active {
            background: var(--color-main-brand-active);
            color: var(--color-main-text-brand-bg-primary);
        }
    }

    :deep(.type-switch-search-box) {
        position: relative;
        width: 348px;
        height: 40px;
        margin-right: 32px;
        display: flex;
        flex-shrink: 0;
        border-radius: 2px;
        border: 1px solid var(--color-main-border-gray);
        justify-content: center;
        align-items: center;
        background: var(--color-main-light-bg-white);
        overflow: hidden;

        .search-input .el-input__wrapper {
            box-shadow: 0 0 0 0px var(--el-input-border-color, var(--el-border-color)) inset;
        }

        .search-btn {
            position: relative;
            width: 86px;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            background-color: var(--color-main-brand);
            color: var(--color-main-text-brand-bg-primary);
            font-size: 16px;
            font-weight: 400;
            border-radius: 0px 2px 2px 0px;
            cursor: pointer;
        }
    }

    @media screen and (max-width: 1600px) {
        :deep(.type-switch-search-box) {
            width: 200px;
        }
    }
}
</style>
